import axios from '@/axios'

const state = {
    postageCost: {},
};

const getters = {
    getPostageCost: (state) => state.postageCost,
};

const mutations = {
    setPostageCost: (state, postageCost) => (state.postageCost = postageCost),
    deletePostageCost: (state, data) => {
        if (state.postageCost[data.tab.code]) {
            state.postageCost[data.tab.code].costs = state.postageCost[data.tab.code].costs
                .filter(item => item.id !== data.item.id);
        }
    },
};

const actions = {
    async loadPostageCost(context, data) {
        await axios().get(`/getPostageCost`)
            .then(response => {
                context.commit('setPostageCost', response.data)
            })
    },
    async postageCostDeleteItem(context, data) {
        await axios().post(`/deletePostageCost/${data.item.id}`)
            .then(response => {
                context.commit('deletePostageCost', data)
            })
    },
    async postageCostUpdateItem(context, data) {
        await axios().post(`/updatePostageCost/${data.item.id}`, data.item)
    },
    async postageCostAddItem(context, data) {
        await axios().post(`/addPostageCost`, data.item)
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
